var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-carousel',_vm._l((_vm.carousel),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":_vm.imageUrl + 'gallery/' + item.name,"height":"100%"}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }